import { supabase, getCurrentUser } from './client';
import signalRService from '../api/signalRService';

// Authentication helpers
export const signUp = async (email, password, userData = {}) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: userData
    }
  });
  return { data, error };
};

export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  return { data, error };
};

export const signOut = async () => {
  try {
    // Reset SignalR service first to ensure clean state between users
    await signalRService.resetService();
    
    // Then sign out from Supabase
    const { error } = await supabase.auth.signOut();
    
    // Force a page reload to clear any cached data
    window.location.href = '/signin?status=signed-out';
    
    return { error };
  } catch (error) {
    console.error('Error during sign out:', error);
    return { error };
  }
};

export const onAuthStateChange = (callback) => {
  // The onAuthStateChange method returns { data: { subscription } }
  const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
    // If user signs out, reset SignalR service to ensure clean state
    if (event === 'SIGNED_OUT') {
      signalRService.resetService().catch(error => {
        console.error('Error resetting SignalR service on auth state change:', error);
      });
    }
    
    callback(session?.user || null, event);
  });
  
  // Return an object with unsubscribe method
  return {
    unsubscribe: () => {
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    }
  };
};

// Re-export getCurrentUser for convenience
export { getCurrentUser }; 